import { styled } from '@nextiva/next-ui-components';
import colors from 'styles/application/_base/_variables.scss';
import { pxToRem } from 'utils/pxToRemConverter';

export const ContainerStyles = styled('div')`
  font-family: Lato, sans-serif;

  .MuiButtonBase-root {
    text-transform: initial;
    font-size: ${pxToRem('14px')};
    font-family: Lato, sans-serif;
    letter-spacing: 0.4px;
    padding: 6px 8px;
    border-radius: 4px;
  }

  .Mui-error {
    color: ${colors.colorErrorPrimary};
    border-color: ${colors.colorErrorPrimary};
  }

  .MuiButton-label {
    height: 27px;
    font-family: Lato, sans-serif;
    font-weight: 700;
  }

  .MuiInputBase-root {
    color: #222648;
    border: 1px solid #a2b6ca;
    display: inline-flex;
    position: relative;
    font-size: 1rem;
    box-sizing: border-box;
    align-items: center;
    font-family: Lato, sans-serif;
    font-weight: 400;
    line-height: 1.1876em;
    border-radius: 4px;
    background-color: #fff;
  }

  .MuiOutlinedInput-root {
    border: 1px solid #a2b6ca;
    padding: 0;
  }

  .MuiOutlinedInput-root.Mui-error {
    border: 1px solid ${colors.colorErrorPrimary};
  }

  .MuiOutlinedInput-input {
    padding: 10px 10px 11px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: unset !important;
    border-color: unset !important;
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(0, 1.5px) scale(0.75);
  }

  .MuiInputLabel-root {
    display: flex;
  }

  .MuiFormLabel-root {
    color: #758ba3;
    font-size: ${pxToRem('10px')};
    font-weight: 800;
    font-family: Lato, sans-serif;
    letter-spacing: ${pxToRem('0.25px')};
  }

  .Label {
    font-weight: 800;
  }

  .MuiInputBase-root.Mui-focused {
    border: 1px solid ${colors.primaryBlue};
  }

  div.header-padding {
    padding: 5px 0 8px 0;
  }

  .platform-modules__info {
    padding: 16px 20px;
    margin: 16px 0;
    font-size: ${pxToRem('14px')};
    background-color: #edf4f7;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  .m-extension-range {
    .Heading6 {
      font-weight: 500;
      letter-spacing: 0.24px;
    }
    &__spacer {
      padding: 20px 0;
    }
    &__input-suffix {
      margin-top: 10px;
    }
  }

  .m-settings-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c9e2e2;

    h1 {
      margin: 0;
    }

    &__heading {
      display: inline-block;
      padding: 20px 0;
      font-size: 1.25rem;
      font-weight: 600;
      font-style: normal;
      line-height: 1.75rem;
      letter-spacing: 0.009375rem;

      &__back-arrow {
        width: 12px;
        height: 12px;
        margin-right: 7px;
        cursor: pointer;
        transform: rotate(90deg);

        path {
          fill: $cool-gray-60;
        }
      }
    }

    &__heading-disabled {
      color: $color-secondary;
    }

    &__children {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .MuiInputLabel-root .nui-label {
    display: block;
    font-size: ${pxToRem('10px')};
    font-family: Lato, sans-serif;
    font-weight: 700;
    line-height: 12px;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  .number-container {
    margin-top: 8px;
    margin-bottom: 66px;
  }

  .additional-numbers-grid {
    width: 100%;
    margin: 8px 0 0 0;
  }

  .phone-number-row {
    display: flex;
    flex-direction: row;
  }

  .m-phone-number {
    &__input-unreachable {
      div:first-of-type {
        width: 100%;
      }

      .MuiInputLabel-root .nui-label {
        margin-bottom: 0;
      }
    }

    &__label-extension {
      .Mui-error {
        color: ${colors.colorErrorPrimary};
      }

      div.Mui-error {
        border: 1px solid ${colors.colorErrorPrimary};
      }

      label:first-of-type {
        flex-direction: column;
      }

      .MuiInputLabel-root .nui-label {
        margin-top: 2px;
        margin-bottom: 9px;
        font-weight: 900;
      }
    }
  }

  .header-close-button {
    bottom: 0;
    display: flex;
    align-items: center;
    color: ${colors.secondaryColor};
    font-size: ${pxToRem('10px')};
    font-weight: 800;
    letter-spacing: 0.25px;
    margin-top: ${pxToRem('8px')};
    border: none;
    background-color: white;
    cursor: pointer;
  }

  .field-container {
    .MuiInput-root.MuiInput-underline:before {
      border-bottom: none;
    }

    .MuiFormHelperText-root {
      font-family: Lato, sans-serif;
    }

    .Mui-focused {
      border: initial;
    }

    .MuiFormLabel-root {
      font-size: ${pxToRem('13px')};
      letter-spacing: 0.035rem;
      color: #758ba3;

      &.Mui-error {
        color: ${colors.colorErrorPrimary};
      }
    }

    .MuiInput-input {
      border-radius: 4px;
      padding: 10px 10px 11px;
    }

    .MuiInputBase-root {
      &.Mui-focused {
        border: 1px solid #005fec;
      }

      &.Mui-error {
        color: ${colors.colorErrorPrimary};
        border-color: #e06969;
      }
    }
  }
`;
